import React from 'react'
import { useForm } from 'react-hook-form'
import { Button, Col, Container, FormGroup, Label, Row,Form, Alert, Spinner } from 'reactstrap'
import useBulkUpload from './useBulkUpload'
// import templateFile from '../../assets/template/Appraisal Bot Bulk Upload Template V2.xlsx';
import templateFile from '../../assets/template/Appraisal_Bulk Order Template.xlsx';
import { useWebSocket } from 'context/WebSocketContext';
import useInitialData from 'context/useInitialData';
import { useQueryClient } from '@tanstack/react-query';

const BulkOrderForm = ({onSuccess}) => {
    const queryClient = useQueryClient()
     // getting the user id from local storage
    const userData = JSON.parse(localStorage.getItem('userData'))
    const credits = Number(userData?.wallet?.free_credit) + Number(userData?.wallet?.debt_credit) + Number(userData?.wallet?.paid_credit);

    const {walletData} = useWebSocket();
    console.log("wallet",walletData)

    const creds = walletData ? Number(walletData.total_balance) : credits;
    console.log("credits",creds)

    const {data:initData} = useInitialData();
    const products = initData?.products || []

    const totalProductPrice = products.reduce((sum,product)=>sum + parseFloat(product.current_price?.price || 0),0 )

    // upload bulk order hook
    const{isPending, isSuccess, uploadBulkOrder} =useBulkUpload();

    const{register,handleSubmit,formState:{errors}}=useForm({
        defaultValues:{
            file:""
        },
        criteriaMode:"all",
        mode:"onChange"
    })

    const onSubmit=(data)=>{
        const file = data.file[0]
        console.log("bulk data",file)
        uploadBulkOrder(file,{
            onSuccess:()=>{
                onSuccess();
                queryClient.invalidateQueries(["creditHistoryPerProduct"]);
                queryClient.invalidateQueries(["creditHistory"]);
            }
        })
    }

    // download template
    const hanldeDownload=()=>{
        const link = document.createElement("a");
        link.href = templateFile;
        link.download = "Appraisal_Template.xlsx";
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
    }

  return (
    <Container fluid>
        {
            creds > 0 && creds < totalProductPrice && (
                <Alert color='danger'>
                    Your credit balance is running low. Please add funds to your account.{''}
                    <a
                        className='alert-link'
                        href='/payments'
                        rel='noreferrer'
                        target='_blank'
                    >
                        Add Credits here
                    </a>
                </Alert>
            )
            
        }
        <Row>
            <Col>
                <Form onSubmit={handleSubmit(onSubmit)}>
                    <Row>
                        <Col>
                            <div className='mb-4 border-bottom pb-2'>
                                <h5 className='fw-bold'>Upload Bulk Orders</h5>
                            </div>
                            <Row>
                                <FormGroup>
                                    <Label htmlFor='file' className='form-label'>Upload Excel File</Label>
                                    <input
                                        type='file'
                                        id='file'
                                        name='file'
                                        className='form-control border-primary-subtle'
                                        {...register("file",{required:"Please Upload a File",
                                            validate:{
                                                acceptedFormats:(files)=>
                                                    files && files.length === 1 && /\.(xlsx|xls)$/i.test(files[0].name) ? true :"Upload one .xlsx or .xls file only"
                                            }
                                        })}
                                    />
                                    <div className="form-text text-muted">
                                        Supported file types: <strong>.xlsx</strong> and <strong>.xls</strong> only.
                                    </div>
                                    {errors.file && <span className="text-danger">{errors.file.message}</span>}
                                </FormGroup>
                                
                            </Row>
                            
                            <Row className='justify-content-center'>
                                <div style={{width:"500px"}}>
                                    <Alert  color="info" className="text-center">
                                    <p className="mb-2">
                                        First time? Download our template to ensure your data is formatted correctly.
                                    </p>
                                    <Button 
                                        type='button' 
                                        className='btn py-2' 
                                        style={{ backgroundColor: "#00ADF0", color: "white" }}
                                        onClick={hanldeDownload}
                                    >
                                        Download Template
                                    </Button>
                                </Alert>
                                </div>
                            </Row>
                            <div className='mb-4 border-bottom pb-2'></div>
                            <Row>
                                <FormGroup>
                                    <Button type='submit' className='btn w-100 py-2' style={{backgroundColor:"#00ADF0", color:"white"}} disabled={isPending}>
                                        {isPending ? <><Spinner size='sm'/> Uploading...</> : 'Upload Orders'}
                                    </Button>
                                </FormGroup>
                            </Row>
                        </Col>
                    </Row>
                </Form>
            </Col>
        </Row>
    </Container>
  )
}

export default BulkOrderForm